export type ImportFailure = { line: number; nome?: string; message: string }

type Props = {
  imported: number
  failed: ImportFailure[]
  repeated: number
}

function isDuplicate(message: string) {
  return /repetido|já está na base/i.test(message)
}

function groupFailures(failed: ImportFailure[]) {
  const counts = new Map<string, number>()
  for (const item of failed) counts.set(item.message, (counts.get(item.message) ?? 0) + 1)
  return [...counts.entries()].map(([message, count]) => ({ message, count }))
}

export function ParceirosImportResult({ imported, failed, repeated }: Props) {
  const invalid = failed.filter((item) => !isDuplicate(item.message))
  const removed = Math.max(repeated, failed.filter((item) => isDuplicate(item.message)).length)
  const groups = groupFailures(invalid)

  return (
    <div className='grid gap-3 rounded-2xl border border-[var(--glass-border)] bg-[var(--bg-main)] p-4 text-left'>
      <p className='text-sm font-medium text-text-primary'>Importação concluída.</p>
      <p className='text-sm text-text-primary'>
        {imported === 1 ? '1 indicação nova.' : `${imported} indicações novas.`}
      </p>
      <p className='text-sm font-medium text-text-primary'>
        {removed === 0
          ? 'Nenhuma duplicata. Os e-mails estavam livres.'
          : removed === 1
            ? '1 duplicata removida. Ficou só o primeiro e-mail.'
            : `${removed} duplicatas removidas. Ficou só o primeiro e-mail.`}
      </p>

      {invalid.length > 0 && (
        <>
          <p className='text-sm text-text-primary'>
            {invalid.length === 1 ? '1 linha não entrou por dado inválido.' : `${invalid.length} linhas não entraram por dado inválido.`}
          </p>
          <ul className='grid gap-1 text-xs text-text-muted'>
            {groups.map((group) => (
              <li key={group.message}>
                {group.count} · {group.message}
              </li>
            ))}
          </ul>
          <ul className='grid max-h-40 gap-1 overflow-y-auto text-xs text-text-muted'>
            {invalid.map((item) => (
              <li key={`${item.line}-${item.message}`}>
                Linha {item.line}
                {item.nome ? ` · ${item.nome}` : ''}: {item.message}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
